import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash, faPlus, faHome } from "@fortawesome/free-solid-svg-icons";
import {
  addProductThunk,
  deleteProductThunk,
  editProductThunk,
  fetchAllProductsThunk,
  fetchOrderByIdThunk,
  fetchOrdersThunk,
  fetchProductByIdThunk,
  updateOrderStatusThunk,
  uploadImageThunk,
} from "../thunks/thunks";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Logo from "./Logo";
// Modal component for adding/editing items
const Modal = ({ isOpen, onClose, onSubmit, formItem, onInputChange, onImageChange, categoriesList }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-11/12 sm:w-96">
        <h2 className="text-xl font-semibold mb-4">{formItem.name ? "Edit Product" : "Add Product"}</h2>
        <form>
          <div className="mb-4">
            <label className="block text-sm font-semibold mb-2" htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formItem.name}
              onChange={onInputChange}
              className="w-full px-4 py-2 border rounded"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-semibold mb-2" htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formItem.description}
              onChange={onInputChange}
              className="w-full px-4 py-2 border rounded"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-semibold mb-2" htmlFor="price">Price</label>
            <input
              type="number"
              id="price"
              name="price"
              value={formItem.price}
              onChange={onInputChange}
              className="w-full px-4 py-2 border rounded"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-semibold mb-2" htmlFor="stock">Stock</label>
            <input
              type="number"
              id="stock"
              name="stock"
              value={formItem.stock}
              onChange={onInputChange}
              className="w-full px-4 py-2 border rounded"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-semibold mb-2" htmlFor="categories">Categories</label>
            <select
              multiple
              id="categories"
              name="categories"
              value={formItem.categories}
              onChange={onInputChange}
              className="w-full px-4 py-2 border rounded"
            >
              {categoriesList.map((category, index) => (
                <option key={index} value={category}>{category}</option>
              ))}
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-semibold mb-2" htmlFor="image">Image</label>
            <input
              type="file"
              onChange={onImageChange}
              className="w-full px-4 py-2 border rounded"
            />
          </div>

          <div className="flex justify-between">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-400 text-white rounded"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onSubmit}
              className="px-4 py-2 bg-blue-600 text-white rounded"
            >
              {formItem.name ? "Update Product" : "Add Product"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const AdminPage = () => {
  const {
    items: products,
    isLoading,
    error,
  } = useSelector((state) => state.products);
  const dispatch = useDispatch();
  const [hasFetched, setHasFetched] = useState(false);

  const [viewMode, setViewMode] = useState("products"); // "products" or "orders"

  const { orders } = useSelector((state) => state.products);
  const handleStatChange = (orderId, newStatus) => {
    // setOrders((prevOrders) =>
    //   prevOrders.map((order) =>
    //     order.id === orderId ? { ...order, status: newStatus } : order
    //   )
    // );
    console.log("changed");
  };

  useEffect(() => {
    if (
      viewMode === "products" &&
      !isLoading &&
      !error &&
      products.length === 0
    ) {
      dispatch(fetchAllProductsThunk());
      setHasFetched(true);
    }
  }, [viewMode, dispatch, isLoading, error, products, hasFetched]);

  const categoriesList = [
    "contemporary western",
    "indo western",
    "trousseau Collection",
    "Designer suits",
    "Designer kurtis",
    "designer sarees",
    "crop top",
    "skirts",
    "mens wear",
    "kids wear",
    "night wears",
    "Designer fabrics",
  ];

  const [formMode, setFormMode] = useState("add"); // "add" or "edit"
  const [formItem, setFormItem] = useState({
    name: "",
    description: "",
    stock: "",
    imageFileName: "",
    categories: [],
    price: "",
    status: "pending", // Default status
  });
  const [orderIdToFind, setOrderIdToFind] = useState(""); // State for input order ID
  const [foundOrderProducts, setFoundOrderProducts] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const {order} = useSelector((state) => state.products);
  const handleFindOrder = async () => {
    if (orderIdToFind.trim()) {
      try{
        const order = await dispatch(fetchOrderByIdThunk(orderIdToFind)).unwrap()
        console.log("order at find:",order);
        const productDetails = await Promise.all(
          order.products.map(async (product)=>{
            const productDetails = await dispatch(fetchProductByIdThunk(product.productId._id)).unwrap()
            return productDetails;
          })
        );

        setFoundOrderProducts(productDetails);
      }
      catch(error){
        console.log(error);
      }
    }
  };
  const handleInputChange = (e) => {
    const { name, value, options } = e.target;
    if(name == "categories"){
      const selectedCategories = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
      setFormItem({
        ...formItem,
        categories: selectedCategories,
      });
    }else{
      setFormItem({
        ...formItem,
        [name]: name === "price" || name === "stock" ? parseFloat(value) : value,
      });
    }
    
  };
  const openAddModal = () => {
    setFormMode("add");
    setFormItem({
      name: "",
      description: "",
      stock: "",
      imageFileName:"",
      categories:[],
      price: "",
    });
    setIsModalOpen(true);
  };

  const openEditModal = (item) => {
    setFormMode("edit");
    setFormItem(item);
    setIsModalOpen(true);
  };

  const handleStatusChange = (orderId, status) => {
    dispatch(updateOrderStatusThunk({orderId, status}));
  };

  const handleSubmit = async () => {
    try {
      if (formMode === "add") {
        const newProduct = { ...formItem };
        await dispatch(addProductThunk(newProduct));
        setIsModalOpen(false);
      } else if (formMode === "edit") {
        await dispatch(editProductThunk(formItem));
        setIsModalOpen(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      dispatch(uploadImageThunk(file))
        .unwrap()
        .then((imageUrl) => {
          setFormItem({ ...formItem, imageFileName: imageUrl });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handleDeleteItem = async () => {
    try {
      await dispatch(deleteProductThunk(itemToDelete));
      window.location.reload();
      setIsDeletePopupOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-custom-pink via-light-custom-pink to-white">
      {/* Navbar */}
      <nav className="flex justify-between items-center bg-white text-black px-6 py-4">
        <div className="flex flex-col ">
          <Link to="/">
          <Logo />
          </Link>
          <h1 className="hidden sm:block sm:text-2xl font-bold">Admin Panel</h1>
        </div>
        <div className="flex items-center space-x-4">
          <p className="text-base sm:text-lg font-semibold">
            Total Items: {products.length}
          </p>
          <button
            className="flex items-center bg-pink-400 hover:bg-green-600 text-white px-3 py-2 sm:px-4 sm:py-2 rounded shadow"
            onClick={openAddModal}
          >
            <FontAwesomeIcon icon={faPlus} className="mr-2" />
            Add Item
          </button>
          <a href="/">
            <FontAwesomeIcon icon={faHome} className="mr-2 text-2xl hover:text-custom-pink" />
          </a>
        </div>
      </nav>
      <Modal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      onSubmit={handleSubmit}
      formItem={formItem}
      onInputChange={handleInputChange}
      onImageChange={handleImageChange}
      categoriesList={categoriesList}
    />
      {/* Header Buttons */}
      <div className="flex justify-center space-x-4 my-4">
        <button
          className={`px-4 py-2 rounded ${
            viewMode === "products"
              ? "bg-black text-white"
              : "bg-gray-200 text-black"
          }`}
          onClick={() => setViewMode("products")}
        >
          Products
        </button>
        <button
          className={`px-4 py-2 rounded ${
            viewMode === "orders"
              ? "bg-black text-white"
              : "bg-gray-200 text-black"
          }`}
          onClick={() => {
            dispatch(fetchOrdersThunk());
            setViewMode("orders");
          }}
        >
          Orders
        </button>
        <button
          className={`px-4 py-2 rounded ${
            viewMode === "find"
              ? "bg-black text-white"
              : "bg-gray-200 text-black"
          }`}
          onClick={() => {
            setViewMode("find");
          }}
        >
          Find
        </button>
      </div>

      {/* Find Order Section */}
      {viewMode == "find" && <div className="my-4 p-4 bg-white rounded shadow">
        <h2 className="text-lg font-semibold mb-2">Find Order</h2>
        <div className="flex items-center space-x-4">
          <input
            type="text"
            value={orderIdToFind}
            onChange={(e) => setOrderIdToFind(e.target.value)}
            placeholder="Enter Order ID"
            className="px-3 py-2 border rounded w-1/2"
          />
          <button
            onClick={handleFindOrder}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Find
          </button>
        </div>
        {foundOrderProducts.length > 0 && (
          <>
          <h3>Address: {order.address.street}, {order.address.city}, {order.address.state}, {order.address.postalCode}, {order.address.country} </h3>
          <div className="flex flex-wrap mt-4">
            {foundOrderProducts.map((product) => (
              console.log("product of order:",foundOrderProducts),
              <div
                key={product._id}
                className="p-4 bg-gray-100 rounded shadow flex flex-col items-center w-[fit-content]"
              >
                <img
                  src={product.imageFileName}
                  alt={product.name}
                  className="h-64 w-32 object-cover rounded"
                />
                <h3 className="mt-2 text-sm font-bold">{product.name}</h3>
                <p className="text-sm text-gray-500">Size: {product.size}</p>
              </div>
            ))}
          </div>
          </>
        )}
      </div>}

      {/* Content */}
      {viewMode === "products" && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 p-4 sm:p-6">
          {products.map((item) => (
            <div
              key={item._id}
              className="bg-white p-4 rounded-lg shadow-md relative flex flex-col pt-8"
            >
              <img
                src={item.imageFileName}
                alt={item.name}
                className="h-96 w-full object-cover rounded"
              />
              <h3 className="text-lg font-bold mt-2">{item.name}</h3>
              <p className="text-gray-500 text-sm sm:text-base">
                ${item.price}
              </p>
              <p className="text-gray-500 text-sm sm:text-base">
                Stock: {item.stock}
              </p>
              <p className="text-gray-700 mt-2 text-sm sm:text-base">
                {item.description}
              </p>
              <div className="absolute top-2 right-2 flex space-x-2">
                <button
                  onClick={() => openEditModal(item)}
                  className="text-blue-600"
                >
                  <FontAwesomeIcon icon={faPen} />
                </button>
                <button
                  onClick={() => {
                    setIsDeletePopupOpen(true);
                    setItemToDelete(item._id);
                  }}
                  className="text-red-600"
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </div>
            </div>
          ))}
        </div>
        
      )
      }
      {viewMode=="products" && isDeletePopupOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-bold mb-4">Confirm Delete</h2>
              <p className="text-gray-700 mb-4">
                Are you sure you want to delete this item? This action cannot be
                undone.
              </p>
              <div className="flex space-x-4">
                <button
                  onClick={handleDeleteItem}
                  className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                >
                  Delete
                </button>
                <button
                  onClick={() => setIsDeletePopupOpen(false)}
                  className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
        {viewMode == "orders" && (
  <div className="p-4 sm:p-6">
    <div className="overflow-x-auto">
      <table className="min-w-full border border-gray-200 table-auto">
        <thead>
          <tr className="bg-black text-white">
            <th className="py-2 px-4 border">Order ID</th>
            <th className="py-2 px-4 border">Status</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {orders.map((order) => (
            <tr key={order._id} className={`${order.status === "cancelled" ? "bg-red-500" : order.status === "delivered" ? "bg-green-500" : ""}`}>
              <td className="py-2 px-4 border break-words">{order._id}</td>
              <td className="py-2 px-4 border">
                <select
                  value={order.status}
                  onChange={(e) => handleStatusChange(order._id, e.target.value)}
                  className="px-2 py-1 border rounded"
                >
                  <option value="placed">Placed</option>
                  <option value="delivered">Delivered</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}

      
    </div>
  );
};

export default AdminPage;
